import React from 'react';
import { useSearchParams, useParams } from 'react-router-dom';

import MainInfo from '../Components/SectionsForCasePage/MainInfo';
import Accounting from '../Components/SectionsForCasePage/Accounting';
import AdditionalInsurance from '../Components/SectionsForCasePage/AdditionalInsurance';

import HeadlinePanel from '../Components/HeadlinePanel';

import subpageSelection from '../styles/SubpageSelection.module.css';

export default function PageOfCase() {
    const { id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const section = searchParams.get('section') || 'main-info';
   
    return (
        <div className='mainContainer'>
            <HeadlinePanel label= 'Карточка дела' type='Назад' />
            <div className='containerInner'>
                <div className={subpageSelection.panel}>
                    <a onClick={() => setSearchParams({ section: 'main-info' })} className={`${subpageSelection.buttonToSubPages} ${section === 'main-info' ? subpageSelection.active : ''}`}>Основное</a>
                    <a onClick={() => setSearchParams({ section: 'accounting' })} className={`${subpageSelection.buttonToSubPages} ${section === 'accounting' ? subpageSelection.active : ''}`}>Отчетность</a>
                    <a onClick={() => setSearchParams({ section: 'additional-insurance' })} className={`${subpageSelection.buttonToSubPages} ${section === 'additional-insurance' ? subpageSelection.active : ''}`}>Дополнительное страхование</a>
                </div>
                <div className='pageWrapper'>
                    {section == 'main-info' ? <MainInfo caseId={id} />
                    : section == 'accounting' ? <Accounting caseId={id} />
                    : section == 'additional-insurance'? <AdditionalInsurance caseId={id} />
                    : <a>Выберите вкладку</a>}
                </div>
            </div>
        </div>
    )
}
